(function () {
  var root = null;
  var panel = null;
  var lastFocus = null;

  function sectionId() {
    return (root && root.getAttribute('data-section-id')) || 'cart-drawer';
  }

  function openDrawer() {
    if (!root || !panel) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    panel.hidden = false;
    document.body.classList.add('cart-drawer-open');
    var closeBtn = panel.querySelector('[data-cart-drawer-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    if (!root || !panel) return;
    root.classList.remove('is-open');
    document.body.classList.remove('cart-drawer-open');
    window.setTimeout(function () {
      if (!root.classList.contains('is-open')) panel.hidden = true;
    }, 280);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function updateBadges(count) {
    var label = count > 99 ? '99+' : String(count);
    document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
      badge.textContent = label;
      badge.hidden = count < 1;
    });
    document.querySelectorAll('[data-cart-count-label]').forEach(function (node) {
      node.textContent = '(' + count + ')';
    });
  }

  function replaceInner(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-cart-drawer-inner]');
    var current = document.querySelector('[data-cart-drawer-inner]');
    if (next && current) current.replaceWith(next);
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId()))
      .then(function (res) {
        if (!res.ok) throw new Error('drawer');
        return res.text();
      })
      .then(replaceInner)
      .then(function () {
        return fetch('/cart.js').then(function (res) {
          return res.json();
        });
      })
      .then(function (cart) {
        updateBadges(cart.item_count || 0);
      });
  }

  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) }),
    }).then(function (res) {
      if (!res.ok) throw new Error('change');
      return refreshDrawer();
    });
  }

  function addFromForm(form) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    }).then(function (res) {
      if (!res.ok) throw new Error('add');
      return refreshDrawer();
    });
  }

  function bind() {
    root = document.querySelector('[data-cart-drawer]');
    if (!root) return;
    panel = root.querySelector('[data-cart-drawer-panel]');

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-cart-drawer-open]');
      if (opener) {
        event.preventDefault();
        openDrawer();
        return;
      }
      if (event.target.closest('[data-cart-drawer-close]')) {
        event.preventDefault();
        closeDrawer();
        return;
      }
      var changer = event.target.closest('[data-cart-change]');
      if (changer && root.contains(changer)) {
        event.preventDefault();
        changeLine(changer.getAttribute('data-line'), changer.getAttribute('data-quantity'));
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (event.defaultPrevented) return;
      if (!form || !form.getAttribute('action') || form.getAttribute('action').indexOf('/cart/add') === -1) return;
      event.preventDefault();
      addFromForm(form).then(openDrawer).catch(function () {
        form.submit();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) closeDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
